"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventStateTitle = exports.EventState = void 0;
var EventState;
(function (EventState) {
    EventState["DRAFT"] = "draft";
    EventState["LIVE"] = "live";
    EventState["COMPLETE"] = "complete";
})(EventState || (exports.EventState = EventState = {}));
const getEventStateTitle = (state) => {
    switch (state) {
        case EventState.DRAFT:
            return 'Draft';
        case EventState.LIVE:
            return 'Live';
        case EventState.COMPLETE:
            return 'Complete';
    }
};
exports.getEventStateTitle = getEventStateTitle;
